import React, { useEffect, useState, useRef } from 'react';
import MenuFilter from './Common/MenuFilter';
import MenuTree from './libs/left-menu-tree';
import ContentViewer from './Common/ContentViewer';
import ScrollIntoView from './Common/ScrollIntoView';
import Location from './Common/Location';

import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as contentActions from '../store/modules/contentSlice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { parseToArray } from './libs/Util';
import { showToast } from './Common/Messages';

const Document = (props) => {
    const LoginStates = useSelector((state) => state.login);
    const ContentStates = useSelector((state) => state.content);
    const prevEditorData = useRef(null);
    const dispatch = useDispatch();
    const ContentActions = bindActionCreators(contentActions, dispatch);
    const location = useLocation();
    const history = useNavigate();
    const { manualId } = useParams();
    const maxManualHistoryCount = 30;

    const getListName = () => {
        const pathSegments = location.pathname.split('/').filter(segment => segment);
        return pathSegments[1] || null;
    };

    let listName = getListName();

    const [menuMode, setMenuMode] = useState('left');
    const [menu, setMenu] = useState({});
    const [accessMenu, setAccessMenu] = useState({});
    const [filteredMenu, setFilteredMenu] = useState({});
    const [menuTree, setMenuTree] = useState(null);
    const [editorData, setEditorData] = useState(null);
    const [contentInfo, setContentInfo] = useState({});
    const from = location.state || '';
    const [categoryList, setCategoryList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedVersion, setSelectedVersion] = useState(null);
    const [contentViewer, setContentViewer] = useState(null);
    const [rightContent, setRightContent] = useState(null);
    const [selectedDocId, setSelectedDocId] = useState("");
    const [nodePath, setNodePath] = useState(location?.state === 'Favorite' || 'DocumentLink' ? ContentStates.nodepath : []);
    const [folderList, setFolderList] = useState([]);
    const [folderItemList, setFolderItemList] = useState([]);
    const [prevListName, setPrevListName] = useState(null);
    const contentInfoRef = useRef(contentInfo);
    const [isMenuCollapse, setIsMenuCollapse] = useState(false);
    const [maxVersion, setMaxVersion] = useState("");
    const [isAccess, setIsAccess] = useState(false);
    const [selectedAccess, setSelectedAccess] = useState(null);


    useEffect(() => {
        getFavoriteManualFolder();
    }, []);

    useEffect(() => {
        checkAccess(listName);
    }, [LoginStates.userId]);

    useEffect(() => {
        if (listName !== prevListName) {
            checkAccess(listName);
            getFavoriteManualFolder();
            setPrevListName(listName);
        }
    }, [location.pathname]);

    useEffect(() => {
        if(Object.keys(menu).length > 0) {
            const filteredAccessMenu = filterAccess(menu);
            if (!filteredAccessMenu || filteredAccessMenu.children.length === 0) {
                if (LoginStates.userId === '' || !LoginStates.userId) {
                    showToast("warning", "로그인이 필요합니다.");
                    history('/login', { state: {pathName: location.pathname} });
                }
                else {
                    showToast("warning", "접근 권한이 없는 메뉴입니다.");
                    history("/");
                }
            }
            setAccessMenu(filteredAccessMenu || {});
        }
    }, [LoginStates.userRole, menu]);

    useEffect(() => {
        if (Object.keys(menu).length > 0 && Object.keys(accessMenu).length !== 0) {
            if(!isAccess) {
                if (LoginStates.userId === '' || !LoginStates.userId) {
                    showToast("warning", "로그인이 필요합니다.");
                    history("/login", { state: {pathName: location.pathname} });
                }
                else {
                    showToast("warning", "접근 권한이 없는 메뉴입니다.");
                    history("/");
                }
            } else 
                processContentInfo(accessMenu, isAccess ? manualId : null);
        }
        getCategoryList();
    }, [accessMenu]);

    useEffect(() => {
        if (Object.keys(accessMenu).length > 0) {
            if (filteredMenu === null) {
                setMenuTree(
                    <div>no result</div>
                );
            } else {
                setMenuTree(
                    <MenuTree data={Object.keys(filteredMenu).length !== 0 ? filteredMenu : accessMenu} onClickNode={onClickNode} nodepath={nodePath} contentType={ContentStates.contentType} current={contentInfo} />
                );
            }
        }
    }, [accessMenu, filteredMenu, nodePath]);

    useEffect(() => {
        contentInfoRef.current = contentInfo;
        if (contentInfo?.item?.documents) {
            const documents = contentInfo.item.documents;
            let docId = ""; let access = "";
            if (documents.length === 0) {
                setContentViewer(<EmptyDocument name={contentInfo.name} />);
            }
            const arrDocId = documents
                .filter(item => item.product === selectedProduct && item.version === selectedVersion);
                

            const getMaxVersion = (arr, product) => {
                return arr
                    .filter(item => item.product === product && item.version)
                    .reduce((max, item) => {
                        return max && max.version > item.version ? max : item;
                    }, null);
            };
            const maxVersionDoc = getMaxVersion(documents, "ace");
            setMaxVersion(maxVersionDoc?.version);
            /* 선택된 제품군과 버전이 있으면 해당 docId를 가지고 오고
               없으면 ace제품군 중 가장 최신 version의 docId를 가지고 오고
               없으면 문서의 제일 처음 등록한 docId를 가지고 온다.
            */
            if (arrDocId.length > 0) {
                docId = arrDocId[0].docId;
                access = arrDocId[0].access;
            } else if (maxVersionDoc) {
                docId = maxVersionDoc.docId;
                access = maxVersionDoc.access;
            } else if (documents.length > 0) {
                docId = documents[0].docId;
                access = documents[0].access;
            }
            setSelectedAccess(access);
            setSelectedDocId(docId);
        }
    }, [contentInfo, selectedProduct, selectedVersion]);

    useEffect(() => {
        if (editorData !== prevEditorData.current) {
            prevEditorData.current = editorData;
            const arrDocBoxPath = contentInfo.item.documents
                .filter(item => item.docId === selectedDocId)
                .map(doc => doc.docBoxPath);
            const docBoxPath = arrDocBoxPath.length > 0 ? arrDocBoxPath[0] : "";
            if (!editorData) {
                setContentViewer(<EmptyDocument name={contentInfo.name} />);
            } else {
                setContentViewer(
                    <ContentViewer
                        ContentInfo={contentInfo}
                        NodePath={nodePath}
                        docId={selectedDocId}
                        editorData={editorData}
                        setEditorData={setEditorData}
                        class={docBoxPath}
                        manualId={manualId}
                        devUserId={LoginStates.userId}
                        devUserName={LoginStates.userName}
                        companySeq={LoginStates.companySeq}
                        folderList={folderList}
                        folderItemList={folderItemList}
                        setFolderList={setFolderList}
                        setFolderItemList={setFolderItemList}
                        selectedAccess={selectedAccess}
                    />
                );
            }
        }
    }, [editorData]);

    useEffect(() => {
        if (selectedDocId) {
            getManual(selectedDocId);
        }
    }, [selectedDocId]);

    useEffect(() => {
        if (contentInfo?.item !== undefined && editorData !== null) {
            if (contentInfo.item.documents.length === 0) {
                setRightContent(<div className="page-index"></div>);
            } else {
                const arrDocBoxPath = contentInfo.item.documents
                    .filter(item => item.docId === selectedDocId)
                    .map(doc => doc.docBoxPath);
                const docBoxPath = arrDocBoxPath.length > 0 ? arrDocBoxPath[0] : "";
                setRightContent(<ScrollIntoView editorData={editorData} manualId={manualId} docId={selectedDocId} devUserId={LoginStates.userId} fullPath={[...(accessMenu?.location ? accessMenu.location.split("/").filter(p => p) : []), ...(contentInfo?.path ? contentInfo.path.slice(0, -1) : [])]} title={contentInfo?.item?.module ?? contentInfo?.item?.documents[0].title} docBox={docBoxPath}/>);
            }
        } else {
            setRightContent(null);
        }
    }, [contentInfo, editorData]);

    const checkAccess = async (path) => {
        const response = await fetch('datas/menu/menu.json', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            }
        });
        const result = await response.json();
        const menu = findMenu(result, path);
        getMenuTree(path, menu.access ?? null);
        const menuAccess = Array.isArray(menu?.access) ? menu.access : [];
        if(menuAccess.length > 0 && !menuAccess.some(item => item.type ===  "" || (item.type === "userId" ? LoginStates[item.type] !== "" : LoginStates[item.type].split(',').filter(role => role.trim() !== "").includes(item.value)))) {
            if(!LoginStates.userId || LoginStates.userId === '') {
                showToast("warning", "로그인이 필요합니다.");
                history('/login', { state: { pathName: location.pathname} });
            }
            else {
                showToast("warning", "접근 권한이 없는 메뉴입니다.");
                history('/');
            }
        }
    };

    const findMenu = (tree, name, visible = true) => {
        for (const node of tree) {
            if (node.route === name) return {...node, visible: node.visible !== null && node.visible !== undefined ? node.visible : visible};
            if (node.hasSub) {
                const result = findMenu(node.submenu, name, node.visible !== null && node.visible !== undefined ? node.visible : visible);
                if (result) return {...result, access: result.access ?? node.access};
            }
        }
        return null;
    };

    const getManual = async (docId) => {
        var body = JSON.stringify({
            DocumentNo: docId
        });
        if (docId !== '') {
            const response = await fetch('api/Document/Manual', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: body
            });
            const result = await response.json();
            setEditorData(result);
        }
    }

    const getMenuTree = (listName, rootAccess) => {
        if (!listName) return;

        fetch('datas/menu/' + listName + '.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json()).then(data => {
                getMenuDocuments(data, data.access ?? rootAccess);
            }).catch(e => {
                history("/");
            });
    };

    const getMenuDocuments = async (menu, defaultAccess) => {
        try {
            const body = JSON.stringify({
                menuPath: listName
            });
            const response = await fetch('api/Document/GetMenuDocuments', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: body
            });
            const result = await response.json();
            const data = updateMenuDocuments(menu.children, result.table, defaultAccess);
            setMenu({...menu, children: data});
        } catch (error) {
            showToast("warning", "메뉴를 조회할 수 없습니다.");
            history('/');
        }
    }

    const updateMenuDocuments = (menu, documents, defaultAccess) => {
        return menu.map(item => {
            let updatedItem = { ...item };
            const matchedDocs = documents.find(doc => doc.manualID === item.manualId);
            if (matchedDocs) {
                updatedItem.documents = JSON.parse(matchedDocs.documents).map(doc => {return {...doc, access: doc.access ? doc.access : defaultAccess}});
            }
            if (item.children) {
                updatedItem.children = updateMenuDocuments(item.children, documents, defaultAccess);
            }
            return updatedItem;
        });
    };

    const getCategoryList = () => {
        fetch('datas/oper/categorytype.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json())
            .then(data => {
                getMenuType(data);
            }).catch(e => {
                history("/");
            });
    }

    const getMenuType = (categorys) => {
        fetch('datas/oper/menutype.json',
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Cache-Control': 'no-cache'
                }
            }).then((resp) => resp.json()).then(data => {
                const result = data
                    .find(item => item.view && item.menuname === accessMenu.cate)?.category || [];
                setCategoryList(result.map(x => {return {...x, sub: categorys.find(c => c.type === x.type)?.version ?? []}}));
            }).catch(e => {
                history("/");
            });
    };

    const getFavoriteManualFolder = () => {
        if (LoginStates.userId === '') return;
        const body = {
            devUserId: LoginStates.userId
        };
        fetch(`api/Document/GetFavoriteManualFolder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                setFolderList(resultData.data.table);
                setFolderItemList(resultData.data.table1);
            });
    };

    const saveManualViewHistory = (manualId, viewDateTime) => {
        const body = {
            manualId: manualId,
            devUserId: LoginStates.userId,
            viewDateTime: viewDateTime
        };
        fetch(`api/Document/SaveManualViewHistory`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
            });
    };

    // 사용자 권한에 따른 문서 필터링 공통 함수
    const filterDocumentsByAccess = (documents) => {
        const accessType = LoginStates;
        return (documents || []).filter(value => {
            // access가 null, 빈 배열, '전체'인 경우 매칭
            if (!value.access || !Array.isArray(value.access) || value.access.length === 0 || value.access.some(type => type.type === "")) {
                return true;
            }
            // if (!userRoles || !Array.isArray(userRoles) || userRoles.length === 0) {
            //     return false;
            // }
            return value.access.some(type => {
                return (
                    type.type === "userId" ? accessType[type.type] !== ''
                    : accessType[type.type] !== '' && accessType[type.type]?.split(',').filter(x => x.trim() !== "")?.includes(type.value)
                )
            }
            )
        });
    };

    const filterAccess = (tree) => {
        // 트리를 재귀적으로 필터링
        const filterNode = (node, index) => {
            const matched = filterDocumentsByAccess(node.documents);
            // 자식 노드 필터링
            const filteredChildren = (node.children || [])
            .map(filterNode)
            .filter(child => child !== null);

            // 루트일 경우 자식 중 매칭된 게 있거나, 루트가 아니면 자신이 매칭되어야 포함
            if (index < 0 || (node.opentab && node.opentab.url !== "") || matched.length || filteredChildren.length > 0) {
                if (node.manualId === manualId) setIsAccess(true);
                return {
                    ...node,
                    documents: matched,
                    children: filteredChildren
                };
            }

            return null;
        };

        const result = filterNode(tree, -1);
        return result;
    }

    const onClickNode = node => {
        if (contentInfoRef.current && contentInfoRef.current.item?.manualId === node.item.manualId) {
        } else {
            setSelectedDocId('');
            setEditorData('');
        }

        if (node.item.manualId) {
            const manualId = node.item.manualId;
            const currentPath = location.pathname;
            const pathSegments = currentPath.split("/");
            const viewDateTime = new Date().toISOString();
            const category = accessMenu?.location?.split("/").pop();
            const path = findModulePath(accessMenu.children, manualId) || [];
            const fullPath = [
                ...(accessMenu?.location ? accessMenu.location.split("/").filter(p => p) : []),
                ...path.slice(0, -1)
            ];
            let newPath = '';
            let tags = node.item.documents?.length > 0 ? parseToArray(node.item.documents[0].tag) : [];
            if (pathSegments.length > 3) {
                pathSegments[pathSegments.length - 1] = manualId;
                newPath = pathSegments.join("/");
            } else {
                newPath = `${currentPath}/${manualId}`;
            }
            saveManualViewHistory(manualId, viewDateTime);
            addManualHistory({ manualId: manualId, path: newPath, fullPath: fullPath, category: category, module: node.name, tag: tags, viewDateTime: viewDateTime });
            history(newPath);
        }
        setNodePath(node.name);
        setSelectedProduct(node.item.documents?.[0]?.product ?? null);
        if (node.item.opentab !== undefined) {
            const userInfo = {
                "userId": LoginStates.userId,
                "sessionId": LoginStates.sessionId
            };
            if (node.item.opentab.SSOID !== undefined && node.item.opentab.SSOID) {
                fetch('api/User/GetNewSSOId', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json; charset=utf-8'
                    },
                    body: JSON.stringify(userInfo)
                }).then((response) => response.json())
                    .then(resultData => {
                        if (resultData.table[0].status.toString() === "0") {
                            const url = node.item.opentab.url;
                            window.open("", node.item.module);
                            let tabForm = document.createElement('form');
                            tabForm.name = 'tabForm';
                            tabForm.method = node.item.opentab.method;
                            tabForm.action = url;
                            tabForm.target = node.item.module;
                            node.item.opentab.data.forEach(function (data) {
                                let input = document.createElement('input');
                                input.setAttribute("type", "hidden");
                                input.setAttribute("name", data.key);
                                if (data.value === 'SSOId') {
                                    input.setAttribute("value", resultData.table[0].ssoid);
                                }
                                else {
                                    input.setAttribute("value", data.value);
                                }
                                tabForm.appendChild(input);
                            });
                            document.body.appendChild(tabForm);
                            tabForm.submit();
                            document.getElementById("tabForm");
                        }
                        else {

                        }
                    });
            } else {
                const url = node.item.opentab.url;
                window.open("", node.item.module);
                let tabForm = document.createElement('form');
                tabForm.name = 'tabForm';
                tabForm.method = node.item.opentab.method;
                tabForm.action = url;
                tabForm.target = node.item.module;
                node.item.opentab.data.forEach(function (data) {
                    let input = document.createElement('input');
                    input.setAttribute("type", "hidden");
                    input.setAttribute("name", data.key);
                    input.setAttribute("value", data.value);
                    tabForm.appendChild(input);
                });
                document.body.appendChild(tabForm);
                tabForm.submit();
                document.getElementById("tabForm");
            }
        }
        setContentInfo(node);
    };

    const menuOpen = () => {
        if (menuMode === 'left') {
            setMenuMode('left open');
        } else {
            setMenuMode('left');
        }
    };

    const processContentInfo = (data, manualId) => {
        if (data.location && !manualId) {
            if (accessMenu.children.length > 0)
                onClickNode({
                    name: accessMenu.children[0].module, item: { documents: accessMenu.children[0].documents, manualId: accessMenu.children[0].manualId }, path: []
                });
            else {
                onClickNode({
                    name: accessMenu.module, item: { documents: [], manualId: '' }, path: []
                });
            }
            return;
        }
        const found = findDocumentsByManualId(data, manualId);
        if (!found) {
            const accesses = LoginStates.userRole.split(',').filter(role => role.trim() !== "") || [];
            const documents = filterDocumentsByAccess(data.documents, accesses);
            onClickNode({
                name: data.module, item: { documents: documents, manualId: data.manualId }, path: []
            });
        }
    };

    const findDocumentsByManualId = (data, manualId, path) => {
        let nodePath = [];

        if (data.location === undefined) {
            nodePath = [...(path ? path : []), data.module ?? ''];
        }
        if (data.manualId === manualId) {
            const accesses = LoginStates.userRole.split(',').filter(role => role.trim() !== "") || [];
            const documents = filterDocumentsByAccess(data.documents, accesses);
            onClickNode({
                name: data.module, item: { documents: documents, manualId: data.manualId }, path: nodePath
            });
            return true;
        }
        if (data.children && data.children.length > 0) {
            for (let child of data.children) {
                if (findDocumentsByManualId(child, manualId, nodePath)) {
                    return true;
                }
            }
        }
        return false;
    };

    const findModulePath = (menu, manualId, path = []) => {
        for (const item of menu) {
            if (item.manualId === manualId) {
                return [...path, item.module];
            }
            if (item.children) {
                const result = findModulePath(item.children, manualId, [...path, item.module]);
                if (result) return result;
            }
        }
        return null;
    };

    const addManualHistory = (item) => {
        const storedData = JSON.parse(localStorage.getItem("manualHistory")) || [];
        // 기존의 동일한 manualId를 가진 항목이 있으면 해당 항목 제거 후 다시 추가
        const index = storedData.findIndex((existingItem) => existingItem.manualId === item.manualId);
        if (index !== -1) {
            storedData.splice(index, 1);
        }
        storedData.push(item);
        if (storedData.length > maxManualHistoryCount) {
            storedData.shift(); // 가장 오래된 항목 제거
        }
        localStorage.setItem("manualHistory", JSON.stringify(storedData));
    };

    return (
        <div className="container doc-type">
            <div className={`contents-wrap ${isMenuCollapse ? "left-hide" : ""}`}>
                <div className={menuMode}>
                    <div class="left-menu-inner">
                        <h3 className="narrow-title">
                            <a onClick={menuOpen}>{accessMenu.module}<i className="i-menu-dropdown"></i></a>
                        </h3>
                        <div class="leftmenu-title-section">
                            <h3 className="tree-title">
                                <a onClick={() => onClickNode({
                                    name: accessMenu.children[0].module,
                                    item: { documents: accessMenu.children[0].documents, manualId: accessMenu.children[0].manualId },
                                    path: []
                                })}>{accessMenu.module}</a>
                            </h3>
                            <button className='btn-sidemenu' onClick={e => setIsMenuCollapse(prev => !prev)}>
                                <i className='icoKdc24 collapse-24'></i>
                            </button>
                        </div>
                        <MenuFilter
                            categoryList={categoryList}
                            menuData={accessMenu}
                            setFilteredMenu={setFilteredMenu}
                        />
                        <div className="left-menu">
                            {menuTree}
                        </div>
                    </div>
                </div>
                <div className="content">
                    {accessMenu?.location && contentInfo?.path && (
                        <Location
                            path={[
                                ...(accessMenu?.location ? accessMenu.location.split("/").filter(p => p) : []),
                                ...(findModulePath(accessMenu.children, contentInfo.item.manualId) || []).slice(0, -1)
                            ]}
                            selectedProduct={selectedProduct ||
                                (contentInfo?.item?.documents?.length > 0 ? contentInfo?.item?.documents[0].product : null)}
                            setSelectedProduct={setSelectedProduct}
                            selectedVersion={selectedVersion}
                            setSelectedVersion={setSelectedVersion}
                            categoryList={categoryList}
                            documents={contentInfo?.item?.documents}
                            isMenuCollapse={isMenuCollapse}
                            setIsMenuCollapse={setIsMenuCollapse}
                            maxVersion={maxVersion}
                        />
                    )}
                    <div className="doc-wrap">
                        {contentViewer}
                        {rightContent}
                    </div>
                </div>
            </div>
        </div>
    );
};

const EmptyDocument = (props) => {
    return (
        <div className="doc-section">
            <div className="editor-section">
                <div className="title-section">
                    <div className="title-btns-wrap">
                        <p>{props.name}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Document;
